var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDividebuyMiniLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#002f6d;}.b{fill:#fff;}.c{fill:#00b3e3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 16,
    rx: 3.453,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M97.7,65.183a1.218,1.218,0,0,0,.928-1.249c0-.953-.709-1.434-1.805-1.434H94.008v.228a3.168,3.168,0,0,1,1.1,2.489,3.078,3.078,0,0,1-.928,2.345l-.177.16v.287h2.885c1.2,0,1.847-.548,1.847-1.51A1.316,1.316,0,0,0,97.7,65.183Zm-1.966-1.316H96.4c.312,0,.456.127.456.4s-.152.38-.456.38h-.666Zm.785,2.75h-.785v-.776h.785c.312,0,.456.135.456.4s-.143.388-.456.388Z",
    transform: "translate(-86.07 -57.256)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M44.963,65.033A2.687,2.687,0,0,1,42.1,67.8H39.8V62.3h2.295A2.655,2.655,0,0,1,44.963,65.033Zm-3.02,1.232a1.232,1.232,0,1,0,0-2.463h-.413v2.455Z",
    transform: "translate(-36.442 -57.073)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividebuyMiniLogo);
export default __webpack_public_path__ + "static/media/dividebuy-mini-logo.b71cf48a8934ad66af4dccce7d2adec0.svg";
export { ForwardRef as ReactComponent };